import { useCallback, useState } from 'react';
import { useMutation } from '@apollo/client';
import { CreateLeadMutation } from '@/query';
import { pushOwnerLeadSubmitted } from '@/utils/gtm';

export function useCreateLead() {
  const [validationError, setValidationError] = useState(null);
  const [onCreateLead, { loading, error }] = useMutation(CreateLeadMutation);

  const onCreate = useCallback(
    ({ name, email, phone, address, numBedrooms, city, zipCode, pageName }) => {
      const variables = {
        input: {
          leadInput: {
            name,
            email,
            phone,
            address,
            numBedrooms,
            city,
            zipCode,
          },
        },
      };
      setValidationError(null);
      pushOwnerLeadSubmitted(pageName);
      return onCreateLead({ variables })
        .then((result) => result.data?.ownerOnboardingLeadCreate?.success)
        .catch((err) => {
          if (err.message?.toLowerCase().startsWith('validation failed')) {
            setValidationError(err.message);
            return;
          }
          throw err;
        });
    },
    [onCreateLead]
  );

  return {
    onCreate,
    loading,
    error,
    validationError,
  };
}
